<template>
  <div>
    <v-toolbar
      app
      dark
      tabs
      color="primary"
      class="edudash-toolbar"
      flat
      :height="computedHeight"
      :extended="navExtensions.hasExtension">
      <v-btn v-if="hasArrowBack" icon @click.stop="setAction">
        <v-icon color="white">arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title :class="computedToolbarTitleClass">
        <v-img :src="require('@/assets/images/logo-home.svg')" width="130px" v-if="!hasArrowBack" />
        <div v-bind:class="computedToolbarTextClass">{{ toolbarText }}</div>
      </v-toolbar-title>
      <v-spacer v-if="toolbarNavActions.spacer.has" class="spacer-no-content"></v-spacer>
      <v-menu offset-y v-if="toolbarNavActions.moreOptions.has">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="(option, index) in toolbarNavActions.moreOptions.actions"
            :key="index"
            @click="option.method"
          >
            <v-list-tile-title>{{ option.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <template v-if="navExtensions.hasTabToolbar" #extension>
        <v-tabs  grow color="primary" slider-color="white">
          <v-tab
            v-for="(tab, index) in computedTabs"
            :key="index"
            class="tab-item"
            @click="goTo(tab.action)"
          >{{ tab.text }}</v-tab>
        </v-tabs>
      </template>
      <template v-else-if="navExtensions.hasInputExtension" #extension >
        <div class="fake-input" @click="goTo('NewPost')">
          <v-icon color="textSecondary">sentiment_very_satisfied</v-icon>
          <div><span>Escreva um comunicado</span></div>
          <v-icon color="textSecondary">image</v-icon>
          <v-icon color="textSecondary">camera_alt</v-icon>
        </div>
      </template>
      <v-menu v-if="!hasArrowBack" bottom left>
        <template v-slot:activator="{ on }">
          <v-btn
            dark
            icon
            v-on="on"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-tile
            v-for="(item, action) in optionsMenu"
            :key="action"
            @click="doMenuAction(action)"
          >
            <v-list-tile-title>{{ item }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import helper from '@/mixins/helper';

export default {
  name: 'ToolbarNav',
  mixins: [helper],
  computed: {
    ...mapGetters([
      'toolbarText',
      'toolbarNavActions',
      'navExtensions',
      'getCity',
    ]),
    optionsMenu() {
      return { ProfileShow: 'Perfil', doLogout: 'Sair' };
    },
    computedTabs() {
      return this.navExtensions.tabs;
    },
    computedToolbarTitleClass() {
      if (this.hasArrowBack) {
        return 'toolbar-title mt-0 ml-0';
      }
      return 'toolbar-title mx-auto';
    },
    computedToolbarTextClass() {
      if (this.hasArrowBack) {
        return 'toolbar-text text-large';
      }
      return 'toolbar-text text-small mt-2';
    },
    computedHeight() {
      if (this.hasArrowBack) {
        return '74px';
      }
      return '96px';
    },
    navIcon() {
      if (this.$route.meta.icon) {
        return this.$route.meta.icon;
      }
      return 'menu';
    },
    hasArrowBack() {
      return this.toolbarNavActions.back.has;
    },
  },
  methods: {
    doMenuAction(action) {
      if (action === 'ProfileShow') {
        this.goTo('ProfileShow');
      } else {
        this.doLogout();
      }
    },
    setAction() {
      this.$router.push({ name: this.toolbarNavActions.back.path });
    },
  },
};
</script>

<style lang="scss" src="@/assets/scss/components/toolbar_nav.scss"/>
